

import React, { useState, useEffect } from 'react';
import Loader from 'react-loaders';
import AnimatedLetters from '../AnimatedLetters';
import HauntedDust from './HauntedDust';
import { AiOutlineEye, AiOutlineGithub } from 'react-icons/ai';
import { BsFillArrowLeftCircleFill, BsFillArrowRightCircleFill } from 'react-icons/bs';
import { projects } from './projectsData';
import './index.scss';

const Projects = () => {
    const [letterClass, setLetterClass] = useState('text-animate');
    const [showingProjects, setShowingProjects] = useState(projects);

    const left = 0;
    const main = 1;
    const right = 2;

    useEffect(() => {
        const delay = window.innerWidth < 768 ? 3000 : 5000;
        const timeoutId = setTimeout(() => {
            setLetterClass('text-animate-hover');
        }, delay);
        return () => clearTimeout(timeoutId);
    }, []);
    useEffect(() => {
        projects.forEach((proj) => {
            
            if (proj.main && proj.main !== '#') {
                const imgMain = new Image();
                imgMain.src = proj.main;
            }
            if (proj.minor && proj.minor !== '#') {
                const imgMinor = new Image();
                imgMinor.src = proj.minor;
            }
        });
    }, []);

    const handlePrev = () => {
        const currentProjects = [...showingProjects];
        const popped = currentProjects.pop();
        popped && currentProjects.unshift(popped);
        setShowingProjects(currentProjects);
    };

    const handleNext = () => {
        const currentProjects = [...showingProjects];
        const shifted = currentProjects.shift();
        shifted && currentProjects.push(shifted);
        setShowingProjects(currentProjects);
    };

    const handleMainClick = (type) => {
        if (showingProjects[main][type] !== '#') {
            window.open(showingProjects[main][type], '_blank');
        }
    };

    return (
        <>
            <div className="container projects-page">
                <HauntedDust />
                <div className="text-zone">
                    <h1>
                        <AnimatedLetters
                            letterClass={letterClass}
                            strArray={['P', 'R', 'O', 'J', 'E', 'C', 'T', 'S']}
                            idx={10}
                        />
                    </h1>

                    <div className="carousel-container">
                        <div
                            className="project-card minor left"
                            style={{ backgroundImage: `url(${showingProjects[left].minor})` }}
                            onClick={handlePrev}
                        >
                            <BsFillArrowLeftCircleFill className="arrow-icon" />
                        </div>

                        <div className="project-main-container">
                            <div
                                className="project-card main"
                                style={{ backgroundImage: `url(${showingProjects[main].main})` }}
                            >
                                <div
                                    className="btn-wrapper left-btn"
                                    onClick={() => handleMainClick('link')}
                                    title="Visit the app"
                                >
                                    <AiOutlineEye className="action-icon" />
                                </div>
                                <div
                                    className="btn-wrapper right-btn"
                                    onClick={() => handleMainClick('repo')}
                                    title="Visit the code"
                                >
                                    <AiOutlineGithub className="action-icon" />
                                </div>
                            </div>
                            <h4 className="project-description">
                                {showingProjects[main].description}
                            </h4>
                        </div>

                        <div
                            className="project-card minor right"
                            style={{ backgroundImage: `url(${showingProjects[right].minor})` }}
                            onClick={handleNext}
                        >
                            <BsFillArrowRightCircleFill className="arrow-icon" />
                        </div>
                    </div>
                </div>
            </div>
            <Loader type="pacman" />
        </>
    );
};

export default Projects;